const tracker = window['__ommi__201910__']
const domain = process.env.REACT_APP_TRACK_DOMAIN || ''

tracker.init({
  server_url: domain,
  show_log: false,
  heatmap_url:
    '//shenyan-uat-cos-1306440315.cos.ap-shanghai.myqcloud.com/smarthub/web.smarthub.heatmap.1.18.17.min.js',
  heatmap: {
    scroll_delay_time: 3000,
    clickmap: 'default',
    mouse_notice_map: 'default',
  },
  batch_send: {
    credentials: true,
    datasend_timeout: 6000,
    send_interval: 6000,
    one_send_max_length: 6,
  },
  source_channel: ['pyck', 'mpyck'],
})

tracker.quick('autoTrack')

export default tracker
